export class Avverkningsanmalan {
    success: string;
    message: string;
}
